import { Component, Inject, inject, OnInit, ViewChild } from '@angular/core';
import {
  ActionsInterface,
  CommonTableComponent,
  QueryParamsModel,
  TableColumn
} from 'src/app/layouts/components/common-table/common-table.component';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { firstValueFrom } from 'rxjs';
import { ProgramBrandingService } from '../../program-branding.service';
interface DataInterface {
  programConfigId: string;
  companyId: string;
  brandId: string;
}

@Component({
  selector: 'vex-brand-history-list',
  standalone: true,
  imports: [
    CommonTableComponent,
    MatDialogModule,
    MatIconModule,
    MatDividerModule
  ],
  templateUrl: './brand-history-list.component.html'
})
export class BrandHistoryListComponent {
  title: string = 'Brand History';
  @ViewChild('cnTable', { static: true })
  commonTableRef!: CommonTableComponent;

  public actions: ActionsInterface[] = [
    {
      key: 'viewFile',
      label: 'View IFC07',
      property: 'fileUrl'
    }
  ];
  public columns: TableColumn<any>[] = [
    {
      label: 'Product Brand Name',
      property: 'brandName',
      type: 'text',
      visible: true
    },
    {
      label: 'Status',
      property: 'status',
      type: 'text',
      visible: true
    },
    {
      label: 'Brand Name Registration Id',
      property: 'brandNameRegistrationId',
      type: 'text',
      visible: true
    },
    {
      label: 'Brand Approve Status',
      property: 'brandApprove',
      type: 'text',
      visible: true
    },
    {
      label: 'Brand Registration Expiration Date',
      property: 'Form08ExpDate',
      type: 'text',
      visible: true
    },
    {
      label: 'Link Company Name',
      property: 'linkCompanyName',
      type: 'text',
      visible: true
    },
    {
      label: 'Published status',
      property: 'uploadToWebsite',
      type: 'text',
      visible: true
    },
    {
      label: 'Notes',
      property: 'notes',
      type: 'text',
      visible: true
    },
    {
      label: 'Created Date',
      property: 'createdAt',
      type: 'text',
      visible: true
    },
    {
      label: '',
      property: 'actions',
      type: 'button',
      visible: true
    }
  ];
  filter: any = {};
  programDetails: any;

  private programBrandingService = inject(ProgramBrandingService);

  constructor(
    @Inject(MAT_DIALOG_DATA) private data: DataInterface,
    private dialogRef: MatDialogRef<BrandHistoryListComponent>,
    private toastr: ToastrService
  ) {}
  ngOnInit(): void {}

  async init() {
    try {
      this.inItFilterOptions();
    } catch {}
  }
  inItFilterOptions() {
    this.filter.where = {
      programConfigId: this.data.programConfigId,
      companyId: this.data.companyId,
      brandId: this.data.brandId
    };
  }
  /**
   * Loads the invoice data into the table component
   *  Query parameters for the invoice service
   */
  async onLoadItemsEvent(queryParams: QueryParamsModel) {
    try {
      await this.init();
      if (Object.keys(this.filter).length) {
        queryParams.filter = JSON.stringify(this.filter);
      }
      let resp = await firstValueFrom(
        this.programBrandingService.getByBrandIdHistoryList(queryParams)
      );

      this.commonTableRef.loadItems(resp);
    } catch (err: any) {
      this.commonTableRef.loadItems(err);
    }
  }

  /**
   * Handles action clicks on the table (e.g. edit button)
   *  Event object containing the action key and data
   */
  async onActionClickEmit(ev: any) {
    let key = ev.action.key;
    let data = ev.data;
    switch (key) {
    }
  }

  onBtnActionClick(ev: any): void {
    console.log('ev :>> ', ev);
  }
}
